import React from "react";
import Modal from "../../../components/ui/modal";
import Button from "../../../components/ui/button";
import { TRescheduleAppointmentDetails } from "../../../types";
import { useCompleteAppointment } from "../../../apis/doctor";

interface IProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  appointment: TRescheduleAppointmentDetails;
}

const CompleteAppointmentModal = ({
  isOpen,
  onClose,
  title,
  appointment,
}: IProps) => {
  const { mutate: completeAppointment, isPending } = useCompleteAppointment();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      title={title}
      className="w-[35%] min-w-[400px] max-w-[500px] p-[40px]"
    >
      <div className="mt-[30px] flex flex-col gap-[30px]">
        <div>
          {`Are you sure you want to mark this appointment with ${appointment["Patient Name"]} as completed?`}
          <br />
          <span className="text-sm text-gray-500">
            This action will close the admission and cannot be undone.
          </span>
        </div>

        <div className="flex items-center justify-end gap-[20px]">
          <Button
            theme="tertiary"
            text="Go Back"
            size="md"
            onClick={() => onClose(false)}
          />

          <Button
            theme="primary"
            text="Yes, Mark as Completed"
            size="md"
            loading={isPending}
            onClick={() => {
              completeAppointment(
                { appointmentId: appointment["Appointment ID"] },
                {
                  onSuccess: () => {
                    onClose(false);
                  },
                }
              );
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CompleteAppointmentModal;
